import CustomDeleteDialog from 'core/components/CustomDeleteDialog'
import { deleteClusterHostGroup } from './actions'

const DeleteClusterHostGroupsDialog = (props) => {
  return (
    <CustomDeleteDialog
      {...props}
      deleteAction={deleteClusterHostGroup}
      title="Delete Cluster(s)"
      resourceLabel="Cluster(s)"
      buildBodyFn={(row) => ({ name: row.name })}
    />
  )
}

export default DeleteClusterHostGroupsDialog
